<template>
  <transition name="slide">
  <div class="notificators-page">

    <div class="widget">
      <div class="header"><h3>Notificators</h3></div>
      <div class="content">
        <ul class="notificator-type-selector">
          <li v-for="item in notificatorTypes" v-bind:key="item" v-on:click.stop="setNotificatorType(item)" v-html="notificatorTypesValues[item]"></li>
        </ul>

        <hr>

        <NotificatorsForm :properties="notificator.properties"></NotificatorsForm>

        <button v-on:click.prevent="saveNotificator">Save</button>
      </div>
    </div>


    <div class="widget">
      <div class="header"><h3>Notificators</h3></div>
      <div class="content">
        <div class="notificator" v-for="notificator in notificators" v-bind:key="notificator.ID">
          <p>{{ notificator.Type }}</p>

          <p>{{ notificator.Properties }}</p>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import NotificatorsForm from "../components/NotificatorsForm.vue"
import API from "../api"
  
export default {
  name: 'notificators-page',
  components: {
    NotificatorsForm
  },
  data () {
    return {
      notificators: [],
      notificator: {
        properties: {
          type: "",

          // email stuff
          EmailAddress: "",
          EmailTitle: "",
          EmailBody: "",

          // SMS and PhoneCall
          PhoneNumber: "",
          SMSBody: "",

          // Slack
          IncomingWebhook: "",

          // Webhook
          URL: "", // the address we'll send the POST request
        }
      },
      notificatorTypes: [
        'email', 'sms', 'slack', 'webhook'
      ],
      notificatorTypesValues: {
        "email": "<i class='fa fa-envelope-o'></i> Email",
        "sms": "<i class='fa fa-commenting-o'></i> SMS",
        "slack": "<i class='fa fa-slack'></i> Slack",
        "webhook": "<i class='fa fa-server'></i> Webhook",
      }
    }
  },
  created() {
    this.fetchNotificators()
  },
  methods: {
    fetchNotificators() {
      var that = this;
      API.get('/notificators').then(function (response) {
        if(response.data.OK) {
            that.notificators = response.data.Notificators
        }
      })
    },
    setNotificatorType(type) {
      this.notificator.properties.type = type;
    }
  }
}
</script>

<style lang="scss">
.notificator {
  padding: 10px;
  border: 1px solid #c7d7e0;
  margin-bottom: 9px;
  border-radius: 2px;
  background: #fff;

  &:hover {
    border: 1px solid #000;
  }
}
ul.notificator-type-selector {
  margin: 0; padding: 0;

  li {
    display: inline-block;
    padding: 6px 38px;
    border: 1px solid #4589ff;
    margin: 2px 6px;
    border-radius: 2px;
    width: 23.6%;
    transition: all 0.6s;
    background: #84cbff;
    color: #fff;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14);
    font-weight: bold;

    i {
      font-weight: 300;
      color: #3f8bb1;
    }

    &:hover {
      box-shadow: 0px 0px 5px #73a6ff;
      cursor: pointer;
    }

    &:active {
      border-color: #000;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/NotificatorsPage.vue